import 'react-phone-number-input/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  type CountryCode as CountryCodeType,
  type NationalNumber as NationalNumberType,
} from 'libphonenumber-js';
import { useState, useEffect } from 'react';
import { CountryCode } from './CountryCode';
import { NationalNumber } from './NationalNumber';

type E164Number = string;

type PhoneFieldProperties = {
  id?: string;
  name?: string;
  label?: string;
  value?: E164Number;
  onChange: (value: E164Number) => void;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  placeholder?: string;
};

const IRELAND_COUNTRY_CODE = 'IE';

export const PhoneField = ({
  id,
  value = '',
  onChange,
  required = false,
}: PhoneFieldProperties) => {
  const receivedPhoneNumber = prependIrelandCountryCode(value);

  const [phoneNumber] = useState(
    parsePhoneNumberFromString(receivedPhoneNumber)
  );
  const [countryCode, setCountryCode] = useState<CountryCodeType | undefined>(
    phoneNumber?.country ?? IRELAND_COUNTRY_CODE
  );
  const [nationalNumber, setNationalNumber] = useState<
    NationalNumberType | string
  >(phoneNumber?.nationalNumber ?? '');

  useEffect(() => {
    if (countryCode && nationalNumber) {
      const formatted = parsePhoneNumberFromString(
        nationalNumber,
        countryCode
      )?.format('E.164');
      if (formatted) {
        onChange(formatted);
      }
    }
  }, [phoneNumber, countryCode, nationalNumber]);

  return (
    <div style={{ display: 'flex', gap: '0.5rem' }} id={id}>
      <CountryCode
        value={countryCode}
        onChange={setCountryCode}
        required={required}
      />
      <NationalNumber
        value={nationalNumber}
        onChange={setNationalNumber}
        required={required}
      />
    </div>
  );
};

function prependIrelandCountryCode(phoneNumber: E164Number): E164Number {
  if (phoneNumber.indexOf('+') !== 0) return `+353${phoneNumber}`;
  return phoneNumber;
}
